import { PropsWithChildren } from 'react';
import styled from 'styled-components';

const InertContainer = styled.div`
  width: 100%;
  height: 100%;
  pointer-events: none;

  * {
    pointer-events: none !important;
  }
`;

export const GraphPicture = ({ children }: PropsWithChildren) => (
  <InertContainer inert>{children}</InertContainer>
);
